import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';
import { Badge } from '@/components/ui/Badge.jsx';
import { Lock } from 'lucide-react';

export default function SalaryComponentsPage({ type }) {
  const isFiltered = type === 'allowance' || type === 'deduction';

  const baseFields = [
    { name: 'code', label: 'Code', required: true },
    { name: 'name', label: 'Name', required: true },
    { name: 'taxable', label: 'Taxable (APIT)', type: 'select', default: 1, options: [
      { value: 1, label: 'Yes' }, { value: 0, label: 'No' },
    ]},
    { name: 'epf_applicable', label: 'EPF Applicable', type: 'select', default: 1, options: [
      { value: 1, label: 'Yes' }, { value: 0, label: 'No' },
    ]},
    { name: 'recurring', label: 'Default Frequency', type: 'select', default: 1, options: [
      { value: 1, label: 'Recurring monthly' }, { value: 0, label: 'One-time / variable' },
    ]},
    { name: 'is_editable', label: 'HR Can Edit Amount', type: 'select', default: 1, options: [
      { value: 1, label: 'Yes — HR can override per employee' },
      { value: 0, label: 'No — locked (system-controlled)' },
    ]},
  ];

  const typeField = { name: 'type', label: 'Type', type: 'select', required: true, default: 'allowance', options: [
    { value: 'allowance', label: 'Allowance (earning)' },
    { value: 'deduction', label: 'Deduction' },
  ]};

  const fields = isFiltered ? baseFields : [baseFields[0], baseFields[1], typeField, ...baseFields.slice(2)];

  const baseColumns = [
    { key: 'code', header: 'Code', sortable: true, className: 'font-mono' },
    { key: 'name', header: 'Name', sortable: true },
    { key: 'taxable', header: 'Taxable', render: (r) => (r.taxable ? 'Yes' : 'No') },
    { key: 'epf_applicable', header: 'EPF', render: (r) => (r.epf_applicable ? 'Yes' : 'No') },
    { key: 'recurring', header: 'Recurring', render: (r) => (r.recurring ? 'Yes' : 'No') },
    { key: 'is_editable', header: 'Editable', render: (r) => r.is_editable
      ? <Badge variant="success">Editable</Badge>
      : <span className="inline-flex items-center gap-1 text-slate-500 text-xs"><Lock className="h-3 w-3" />Locked</span>
    },
  ];

  const typeColumn = { key: 'type', header: 'Type', render: (r) => <Badge variant={r.type === 'allowance' ? 'success' : 'warning'}>{r.type}</Badge> };
  const columns = isFiltered ? baseColumns : [baseColumns[0], baseColumns[1], typeColumn, ...baseColumns.slice(2)];

  return (
    <MasterCrudPage
      title={isFiltered ? (type === 'allowance' ? 'Allowances' : 'Deductions') : 'Salary Components'}
      description={isFiltered ? (type === 'allowance' ? 'Earning allowance components' : 'Deduction components') : 'Allowances and recurring deductions'}
      endpoint="/salary-components"
      queryKey={['salaryComponents']}
      fields={fields}
      filterFn={isFiltered ? (r) => r.type === type : undefined}
      serialize={(v) => ({ ...v,
        type: isFiltered ? type : v.type,
        taxable: Boolean(Number(v.taxable)),
        epf_applicable: Boolean(Number(v.epf_applicable)),
        recurring: Boolean(Number(v.recurring)),
        is_editable: Boolean(Number(v.is_editable)),
        ...(v.active != null && { active: Boolean(Number(v.active)) }),
      })}
      columns={columns}
    />
  );
}
